import React, { useState, useEffect } from "react";
import DesService from "../../Services/Des Service";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFolderOpen, FaSignOutAlt, FaUser } from "react-icons/fa";
import { Badge, Card, Container, NavDropdown, Table } from "react-bootstrap";
import Footer from "../Footer";
import { IIP_DOMAIN, LOGIN_DOMAIN, RAIN_DOMAIN,  BUSINESSREG_DOMAIN,  YIELD_DOMAIN, TRAS_DOMAIN, ASI_DOMAIN, MDP, SLAP_DOMAIN, VIS_DOMAIN, ADMIN_DOMAIN, PRICE_STATISTICS, ICS_DOMAIN, AS2, AREA_STATISTICS } from "../../Services/Configuration";
import ShowAlert from "../alert";
import { GiPlantRoots } from "react-icons/gi";
import { MdDateRange, MdEditDocument, MdHome, MdOutlineDateRange, MdWavingHand } from "react-icons/md";
import { TbLockPassword, TbReportSearch } from "react-icons/tb";
import { RiLockPasswordLine } from "react-icons/ri";
import { CiLock } from "react-icons/ci";
import { IoLogOutOutline } from "react-icons/io5";
import { HiOutlineLogout } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { GoFileSubmodule } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";






const moduleColors = {
  "2": {
    titleColor: "#7c3aed",
    iconBg: "#f3e8ff",
    gradient: "linear-gradient(90deg, #7c3aed, #9c27b0)",
  },

  "3": {
    titleColor: "#e91e63",
    iconBg: "#fce4ec",
    gradient: "linear-gradient(90deg, #e91e63, #c2185b)",
  },

  "8": {
    titleColor: "#ff6d00",
    iconBg: "#fff3e0",
    gradient: "linear-gradient(90deg, #ff9800, #ff6d00)",
  },

  "11": {
    titleColor: "#00897b",
    iconBg: "#e0f2f1",
    gradient: "linear-gradient(90deg, #009688, #00796b)",
  },

  "12": {
    titleColor: "#1e88e5",
    iconBg: "#e3f2fd",
    gradient: "linear-gradient(90deg, #1e88e5, #1565c0)",
  },

  "14": {
    titleColor: "#43a047",
    iconBg: "#e8f5e9",
    gradient: "linear-gradient(90deg, #43a047, #2e7d32)",
  },
  "16": {
    titleColor: "#00acc1",
    iconBg: "#e0f7fa",
    gradient: "linear-gradient(90deg, #00bcd4, #00838f)",
  },
  "6": {
    titleColor: "#7c3aed",
    iconBg: "#f3e8ff",
    gradient: "linear-gradient(90deg, #7c3aed, #5e35b1)",
  },

  "9": {
    titleColor: "#ff6d00",
    iconBg: "#fff3e0",
    gradient: "linear-gradient(90deg, #ff9800, #ff6d00)",
  },

  "10": {
    titleColor: "#00897b",
    iconBg: "#e0f2f1",
    gradient: "linear-gradient(90deg, #009688, #00796b)",
  },

  "7": {
    titleColor: "#1e88e5",
    iconBg: "#e3f2fd",
    gradient: "linear-gradient(90deg, #1e88e5, #1565c0)",
  },

  "5": {
    titleColor: "#43a047",
    iconBg: "#e8f5e9",
    gradient: "linear-gradient(90deg, #43a047, #2e7d32)",
  },

  "15": {
    titleColor: "#00897b",
    iconBg: "#e0f2f1",
    gradient: "linear-gradient(90deg, #009688, #00796b)",
  },

  "24": {
    titleColor: "#ff6d00",
    iconBg: "#fff3e0",
    gradient: "linear-gradient(90deg, #ff9800, #ff6d00)",
  },
    "22": {
    titleColor: "#ff6d00",
    iconBg: "#fff3e0",
    gradient: "linear-gradient(90deg, #ff9800, #ff6d00)",
  },
};

function ModuleCard({ mod, animClass }) {
  const styles = moduleColors[mod.sub_id] || {};

  return (
    <div
      className={`module-card animate-in ${animClass}`}
      style={{
        "--title-color": styles.titleColor,
        "--icon-bg": styles.iconBg,
        "--btn-gradient": styles.gradient,
      }}
    >
      <div className="card-icon-title">
        <div className="card-icon">
          <span style={{ fontSize: 22 }}>{mod.icon}</span>
        </div>

        <span className="card-title">{mod.title}</span>
      </div>
      <ul className="card-list">
        <li>{mod.desc}</li>
      </ul>

      <button className="view-module-btn" onClick={mod.onClick}>
        View Module →
      </button>
    </div>
  );
}

export default function MenuHead() {
  const [activeNav, setActiveNav] = useState("home");
  const [selectedModule, setSelectedModule] = useState(0);

  const [moduleList, setModulelist] = useState([]);

  const SubId = localStorage.getItem("subId");
  let psswdDays = localStorage.getItem("psswdDays");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    const modules = JSON.parse(localStorage.getItem("Module")) || [];
    const subModules = JSON.parse(localStorage.getItem("SubModule")) || [];

    const modulelist = modules.map((item) => ({
      ...item,
      submoduleList: subModules.filter((sub, index, self) => sub.module_id === item.module_id && index === self.findIndex((t) => t.sub_module_id === sub.sub_module_id)),
    }));

    setModulelist(modulelist);
  }, []);

  const [enteryFormServices, setEntryFormServices] = useState([]);
  const [SubmoduleServices, setSubmoduleServices] = useState([]);
  const fetchData = async () => {
    try {
      let menu = JSON.parse(localStorage.getItem("Menu"));
      console.log("Menu Data:", menu);
      setEntryFormServices(menu);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const locale = "en";
  const day = new Date().toLocaleDateString(locale, { weekday: "long" });
  const date = `${day}, ${new Date().getDate()} ${new Date().toLocaleDateString(locale, { month: "long" })} ${new Date().toLocaleDateString(locale, { year: "numeric" })}\n\n`;

  const renderSubMenu = (subMenu) => {
    return (
      <NavDropdown style={{ width: "400px" }}>
        {subMenu.subchilds.map((subItem, subIndex) => (
          <NavDropdown.Item key={subIndex} href={subItem.subchild_targeturl}>
            {subItem.subchild_menuitemname}
          </NavDropdown.Item>
        ))}
        <NavDropdown.Divider />
      </NavDropdown>
    );
  };

  const [ModEnb, setModEnb] = useState(true);
  const [Id, setId] = useState(null);

  const domainMapping = {
    9: IIP_DOMAIN,
    2: RAIN_DOMAIN,
    10: ASI_DOMAIN,
    6: BUSINESSREG_DOMAIN,
    16:AS2,
    3: YIELD_DOMAIN,
    12: TRAS_DOMAIN,
    8: AREA_STATISTICS,
    24: MDP,
    5: SLAP_DOMAIN,
    7:PRICE_STATISTICS,
    11:VIS_DOMAIN,
    22:ADMIN_DOMAIN,
    14: ICS_DOMAIN,

  };

  const Modulelogin = (id) => {
    setId(id);

    let params = {
      userId: localStorage.getItem("username"),
      roleId: localStorage.getItem("roleid"),
      subModuleId: id,
      token: localStorage.getItem("token"),
    };

    if (domainMapping.hasOwnProperty(id)) {
      DesService.getModuleData(params).then((res) => {
        localStorage.setItem("subId", id);

        localStorage.setItem("Subdata", JSON.stringify(res?.data?.SDESC || {}));

        setSubmoduleServices(res?.data?.SDESC || {});

        const domain = domainMapping[id];
        const url = `${domain}/MenuHeader?subModuleId=${id}`;

        window.location.href = url;
      });
    } else {
      ShowAlert("Not an Appropriate Module,Do select another one", "warning").then(() => {
        setModEnb(true);
      });

      console.error(`Unrecognized subModuleId: ${id}`);
    }
  };

  const Switchenb = () => {
    let params = {
      userId: localStorage.getItem("username"),
      roleId: localStorage.getItem("roleid"),
      subModuleId: null,
      token: localStorage.getItem("token"),
    };
    DesService.getModuleData(params).then((res) => {
      localStorage.setItem("Subdata", JSON.stringify(res?.data?.SDESC));
      setSubmoduleServices(res?.data?.SDESC);
      // history.push("/MenuHead")
    });
    localStorage.removeItem("subId");
  };



  const getModuleIcon = (id) => {
  switch (id?.toString()) {
    case "1":
      return "🌾";

    case "2":
      return "💰";

    case "3":
      return "🏭";

    case "4":
      return "👥";

    case "7":
      return "🏛️";

    case "20":
      return "📈";

    default:
      return "📂";
  }
};
  const getSubModuleImage = (id) => {
    const imageMap = {
      "2": "../images/rainfall.png",
      "3": "../images/yield.png",
      "8": "../images/area.png",
      "11": "../images/village.png",
      "12": "../images/tras.png",
      "14": "../images/ics.png",
      "16": "../images/growth.png",
      "6": "../images/register.png",
      "9": "../images/iip.png",
      "10": "../images/industry.png",
      "7": "../images/price.png",
      "5": "../images/social.png",
      "15": "../images/accounts.png",
      "24": "../images/social.png",
      "22": "../images/admin.png",
    };

    return imageMap[id] || null;
  };
  function handleLogOut() {
    let params = {
      token: token,
    };
    Swal.fire({
      text: "Are You Sure Want to Log Out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      localStorage.removeItem("username");
      if (result.isConfirmed) {
        navigate("/Logout.do");
      }
    });
  }
  return (
    <>

      <div className="app-wrapper">
        <div style={{ position: "sticky", top: 0, zIndex: 1050, background: "#fff" }}>
          {/* Header */}
          <div className="main-header">
            <div className="header-logo-area">
              <div className="header-logo">
                <img src="../images/aplogo.webp" alt="APlogo" style={{ width:"70px",height:"auto" }} />
              </div>
              <div className="header-title">
                <h1>Directorate of Economics &amp; Statistics</h1>
                <p>Government of Andhra Pradesh</p>
              </div>
            </div>
            <div className="header-right">
   
              <NavDropdown
                align="end"
                id="user-dropdown"
                title={
                  <div className="user-box">
                    <div className="user-avatar">
                      <FaUser style={{ fontSize: 18, color: "#fff" }} />
                    </div>

                    <div className="user-info">
                      <div className="user-name">{localStorage.getItem("displayName")}</div>

                      <div className="user-last-login">Last login: {localStorage.getItem("lastlogintime")}</div>
                    </div>
                  </div>
                }
              >
                <NavDropdown.Item onClick={handleLogOut}>Logout</NavDropdown.Item>
              </NavDropdown>
            </div>
          </div>

          {/* Navigation */}
          <nav className="main-nav">
            {enteryFormServices?.map((menuItem, index) => (
              <React.Fragment key={index}>
                {menuItem.childs ? (
                  <NavDropdown
                    title={
                      <>
                        <span className="nav-icon">
                          {menuItem.menuitemname === "Home" && <MdHome style={{ fontSize: "20px" }} />}
                          {menuItem.menuitemname === "Data Entry" && <MdEditDocument style={{ fontSize: "20px" }} />}
                          {menuItem.menuitemname === "Reports" && <TbReportSearch style={{ fontSize: "20px" }} />}
                          {menuItem.menuitemname === "Change Password" && <TbLockPassword style={{ fontSize: "20px" }} />}
                          {menuItem.menuitemname === "Logout" && <HiOutlineLogout style={{ fontSize: "20px" }} />}
                        </span>

                        {menuItem.menuitemname}
                      </>
                    }
                    id={`nav-dropdown-${index}`}
                    className="nav-item-btn"
                  >
                    {menuItem.childs.map((childItem, childIndex) => (
                      <NavDropdown.Item key={childIndex} href={childItem.targeturl_c}>
                        {childItem.menuitemname_c}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ) : (
                  <a href={menuItem.targeturl} className={`nav-item-btn ${activeNav === menuItem.menuitemname ? "active" : ""}`} onClick={() => setActiveNav(menuItem.menuitemname)}>
                    <span className="nav-icon">
                      {menuItem.menuitemname === "Home" && <MdHome style={{ fontSize: "20px" }} />}
                      {menuItem.menuitemname === "Data Entry" && <MdEditDocument style={{ fontSize: "20px" }} />}
                      {menuItem.menuitemname === "Reports" && <TbReportSearch style={{ fontSize: "20px" }} />}
                      {menuItem.menuitemname === "Change Password" && <TbLockPassword style={{ fontSize: "20px" }} />}
                      {menuItem.menuitemname === "Logout" && <HiOutlineLogout style={{ fontSize: "20px" }} />}
                    </span>

                    {menuItem.menuitemname}
                  </a>
                )}
              </React.Fragment>
            ))}
          </nav>
        </div>
        <Container>
          <div className="welcome-banner">
            <div className="welcome-text">
              <h2>
                Welcome {localStorage.getItem("displayName")} <MdWavingHand style={{ fontSize: "20px", color: "#eab308" }} />
              </h2>
              <p>Access and Manage Modules seamlessly.</p>
            </div>

            <div className="banner-illustration">
              <img src="../images/welcomeimg.png" className="w-100" />
            </div>
          </div>
          {ModEnb && (
            <>
              {/* Main Layout */}
              <div className="main-layout">
                <div className="modules-sidebar">
                  <div className="sidebar-header">
                    <h2 className="sidebar-title">
                      <GoFileSubmodule style={{ color: "#eab308", fontSize: "25px" }} className="me-2" /> Modules
                    </h2>
                  </div>

                  <div className="modules-list">
                    {moduleList?.map((item, index) => (
                      <button key={item.module_id} className={`module-item ${selectedModule === index ? "active" : ""}`} onClick={() => setSelectedModule(index)}>
                        <span className="module-item-icon">{getModuleIcon(item.module_id)}</span>

                        <div className="module-item-text">
                          <span className="module-item-name">{item.module_name}</span>

                          <span className="module-item-desc">{item?.submoduleList?.length || 0} Sub Modules</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Right Content Panel */}
                {moduleList?.[selectedModule] ? (
                  <div className="content-panel">
                    <div className="content-header">
                      <div className="content-header-icon">{getModuleIcon(moduleList[selectedModule].module_id)}</div>

                      <h1 className="content-header-title">{moduleList[selectedModule].module_name}</h1>

                      <p className="content-header-desc">Explore the available sub-modules under {moduleList[selectedModule].module_name}</p>
                    </div>

                    <div className="content-body">
                      <label className="submodules-label">Available Sub-modules</label>
                      <div className="section-cards-row">
                        {moduleList[selectedModule]?.submoduleList?.map((mod, i) => {
                          const getDescription = (id,name) => {
                            switch (id) {
                              case "9":
                                return "Index of Industrial Production";

                              case "24":
                                return "District/Constituency/Mandal -Domestic Product";

                              case "10":
                                return "Annual Survey of Industries";

                              case "14":
                                return "Improvement of Crop Statistics";

                              case "12":
                                return "Timely Reporting of Agricultural Statistics";  

                              case "16":
                                return "Agricultural Statistics Version 2.0"; 
                              case "6":	 
                                return "Business Register";
                                case "22":	 
                                return "Admin Panel";
                              default:
                                return `${name} Module`;
                            }
                          };

                          return (
                            <ModuleCard
                              key={mod.sub_module_id}
                              mod={{
                                title: mod.sub_module_name?.trim(),
                                sub_id: mod.sub_module_id,
                                icon: (
                                  <img
                                    src={getSubModuleImage(mod?.sub_module_id)}
                                    alt={mod?.sub_module_name}
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      objectFit: "contain",
                                    }}
                                  />
                                ),

                                desc: getDescription(mod.sub_module_id,mod.sub_module_name),

                                onClick: () => {
if(["5"].includes(mod.sub_module_id)){return;}
                                  Modulelogin(mod.sub_module_id)
                                }
                              }}
                              animClass={`animate-in-${i + 1}`}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="content-panel">
                    <div className="empty-state">
                      <div className="empty-state-icon">📭</div>
                      <p>Select a module to view details</p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </Container>
      </div>
        <Footer />

    </>
  );
}
